document.cookie =
  'presonus-shop-session-idtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';
document.cookie =
  'presonus-shop-session-accesstoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';
document.cookie =
  'presonus-shop-session-refreshtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';

document.cookie =
  'fender-connect-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.hostname + '';
document.cookie =
  'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';
document.cookie =
  'fender-connect-session-cookie-expiration_time=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';
document.cookie =
  'fender-connect-start=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + window.location.hostname + '';
document.cookie =
  'fender-connect-user-properties=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';
document.cookie =
  'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
  window.location.hostname +
  '';

var parts = location.hostname.split('.');
var sndleveldomain = parts.slice(-2).join('.');

if (sndleveldomain && sndleveldomain.length) {
  document.cookie =
    'presonus-shop-session-idtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'presonus-shop-session-accesstoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'presonus-shop-session-refreshtoken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    sndleveldomain +
    '';

  document.cookie =
    'fender-connect-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'fender-connect-session-cookie-expiration_time=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' +
    sndleveldomain +
    '';
  document.cookie =
    'fender-connect-start=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'fender-connect-user-properties=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
  document.cookie =
    'fender-connect-session-cookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.' + sndleveldomain + '';
}

Object.keys(document.cookie).forEach(cookie => {
  document.cookie.split(';').forEach(function(c) {
    if (c.trim().startsWith('CognitoIdentityServiceProvider')) {
      const name = c.split('=')[0].trim();
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  });
});

const cartAttributes = {
  attributes: {
    request_url: '',
    jwt: '',
    fcID: '',
    prsID: '',
    customer_id: '',
    site: '',
    region: '',
    shopifyCustomerID: '',
    sub_exists: '',
    sub_status: '',
    legacy_sub: ''
  }
};

fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(cartAttributes)
}).then(response => {});
